export default class CrowdfundingProgress {
    constructor(progressBar) {
        this.progressBar = progressBar;
        setTimeout(() => {
            let percentage = this.progressBar.dataset.progressPercentage;

            percentage = percentage > 100 ? 100 : percentage;
            this.progressBar.style.width = percentage + '%';

            if (percentage > 90) {
                this.progressBar.classList.add('c-crowdfunding-progress__bar--shift');
            }
        }, 500);
    }
}